<template>
  <com-page>
    <com-search :columns="searchColumns" @search="handleSearch"></com-search>
    <com-card>
      <com-table ref="table" :columns="columns" :api="api" :defaultParams="defaultParams">
        <template #operation="row">
          <el-button type="primary" size="mini" @click="handleDetail(row.data)">详情</el-button>
        </template>
        <template #type="row">
          {{ shopType[row.data.type] }}
        </template>
      </com-table>
    </com-card>
    <the-feedback-details ref="detail"></the-feedback-details>
  </com-page>
</template>

<script>
import { listApi } from '@/api/feedback'
import theFeedbackDetails from './components/the-feedback-details'

export default {
  components: { theFeedbackDetails },
  data() {
    return {
      api: listApi,
      defaultParams: {
        type: ''
      },
      shopType: {
        PARTNER: '合伙人',
        BUSINESS: '商家'
      },
      searchColumns: [
        {
          label: '商家',
          prop: 'condition',
          type: 'input'
        },
        {
          label: '联系方式',
          prop: 'phone',
          type: 'input'
        },
        {
          label: '商家类型',
          prop: 'type',
          type: 'select',
          option: [
            {
              label: '商家',
              value: 'BUSINESS'
            },
            {
              label: '合伙人',
              value: 'PARTNER'
            }
          ]
        }
      ],
      columns: [
        {
          label: '商家名称',
          prop: 'name'
        },
        {
          label: '商家类型',
          prop: 'type',
          type: 'slot',
          slotName: 'type'
        },
        {
          label: '联系方式',
          prop: 'phone'
        },
        {
          label: '问题过程',
          prop: 'description'
        },
        {
          label: '操作',
          prop: 'operation',
          type: 'slot',
          slotName: 'operation'
        }
      ]
    }
  },
  methods: {
    handleDetail(row) {
      this.$refs.detail.open(row)
    },
    handleCreated() {},
    handleSearch(val) {
      console.log('val :>> ', val)
      this.$refs.table.search(val)
    }
  }
}
</script>

<style lang="scss" scoped></style>
